var map = {
	"./Accomplishment.png": 1373,
	"./Calendar-VGL-icon.png": 818,
	"./CollapseFilled.png": 676,
	"./GlobalGivingCausesThumb.png": 1093,
	"./Mistake.png": 1374,
	"./TablePlaceholder.png": 586,
	"./appointments.png": 1375,
	"./calendar.png": 1376,
	"./class-duration-icon.png": 1377,
	"./clients.png": 1378,
	"./dashboard.png": 71,
	"./delete.png": 1379,
	"./event-calendar.png": 1103,
	"./excel-icon.png": 1380,
	"./personal.png": 1381,
	"./reports.png": 1382,
	"./sales.png": 1383,
	"./vector-cover-image.png": 1384,
	"./vectorglobal.png": 1385,
	"./vectorgloballogo.png": 1386,
	"./vg-logo.png": 1095,
	"./vgl-blank-image.png": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1102;